import React, { useContext, useEffect, useState } from "react";
import "../../../leaveNotes/leaveNotePopup.css";
import "../../organization/department/DepartmentPopup.css";
import CloseIcon from "../../../../images/CloseIcon.svg";
import AuthContext from "../../../context/auth-context";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Fetchdata } from "../../../hooks/getData";
import UpperbarContext from "../../../context/upperbar-context";
import Toast from "../../../Toast";
import $ from "jquery";

export default function FiscalPopup({
  setFiscalPopup,
  reload,
  setReload,
  fiscalFormValue,
  setFiscalFormValue,
  fiscalFormError,
  setFiscalFormError,
  fscList,
  isCurrent,
  setIsCurrent,
  fiscalPopup,
}) {
  const { User } = useContext(AuthContext);
  const { mode, appURL } = useContext(UpperbarContext);
  const closePopUp = (e) => {
    setFiscalPopup(false);
    setFiscalFormError({});
    $(".addFiscalPopBg").fadeOut(500);
    $(".addFiscalPop").slideUp(500);
    setIsSubmit(false);
  };

  useEffect(() => {
    if (fiscalPopup) {
      $(".addFiscalPopBg").fadeIn(500);
      $(".addFiscalPop").slideDown(500);
    }
  }, [fiscalPopup]);

  const handleChange = (e) => {
    const target = e.target;
    const name = target.name;
    const value = target.type == "checkbox" ? target.checked : target.value;
    setFiscalFormValue({ ...fiscalFormValue, [name]: value });
  };

  const [isSubmit, setIsSubmit] = useState(false);

  const validate = (values) => {
    const errors = {};
    const numv = /^[0-9]+$/i;

    if (!values.fiscal) {
      errors.fiscal = mode === "en" ? "Required" : "आवश्यक छ";
    } else if (!numv.test(values.fiscal)) {
      errors.fiscal = mode === "en" ? "Must be digits" : "अंक हुनुपर्छ";
    }
    if (!values.start) {
      errors.start = mode === "en" ? "Required" : "आवश्यक छ";
    } else if (!numv.test(values.start)) {
      errors.start = mode === "en" ? "Must be digits" : "अंक हुनुपर्छ";
    }
    if (!values.end) {
      errors.end = mode === "en" ? "Required" : "आवश्यक छ";
    } else if (!numv.test(values.end)) {
      errors.end = mode === "en" ? "Must be digits" : "अंक हुनुपर्छ";
    }else if (values.end <= values.start) {
      errors.end = mode === "en" ? "Must be greater than start date" : "सुरू मिति भन्दा बढी हुनुपर्छ";
    } 

    return errors;
  };

  const formSubmit = (e) => {
    e.preventDefault();
    setFiscalFormError(validate(fiscalFormValue));
    setIsSubmit(true);
  };

  useEffect(() => {
    if (Object.keys(fiscalFormError).length === 0 && isSubmit) {
      const dataForm = {
        AuthCode: User.AuthCode,
        ComID: User.ComID,
        UserID: User.UID,
        Flag: "i",
        FiscalYear: fiscalFormValue.fiscal,
        StartDate: fiscalFormValue.start,
        EndDate: fiscalFormValue.end,
        BranchID: User.BranchID,
        FiscalID: User.FiscalID,
        FetchURL: `${appURL}api/admin/fiscal`,
        Type: "POST",
      };

      Fetchdata(dataForm).then(function (result) {
        if (result.StatusCode === 200) {
          setFiscalPopup(false);
          $(".addFiscalPopBg").fadeOut(500);
          $(".addFiscalPop").slideUp(500);
          fscList();
          toast.success(result.Message, {
            style: {
              color: "green",
              fontSize: "13px",
            },
            theme: "light",
          });
        } else {
          toast.error("Error: " + result.Message, {
            style: {
              color: "red",
              fontSize: "13px",
            },
            theme: "light",
          });
        }
      });

      setIsSubmit(false);
    }
  }, [fiscalFormError]);

  const handleOnChange = (e) => {
    setIsCurrent(!isCurrent);
    if (e.target.checked === true) {
      setIsCurrent(1);
    } else if (e.target.checked === false) {
      setIsCurrent(0);
    }
  };

  return (
    <>
      {/* <Toast /> */}
      <div className="container newpopup-bg addFiscalPopBg">
        <div className="newpopup addFiscalPop">
          <div className="newpopup-head ps-0 pe-0">
            <div className="popUpTitle">
              {mode === "en" ? "Fiscal" : "वित्तीय"}
            </div>
            <div className="popUpClose">
              <img
                className="popUpCloseIcon"
                src={CloseIcon}
                alt="CloseIcon"
                onClick={closePopUp}
              />
            </div>
          </div>
          <div className="newpopup-body ps-3 pe-3">
            <div className="form-in-padding">
              <div className="row text-start mt-1 ">
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="row text-start ">
                    <div className="form-group mt-2">
                      <label htmlFor="fiscal" style={{ fontSize: "12px" }}>
                        {mode === "en" ? "Fiscal Year" : "वित्तीय वर्ष"}
                        <sup style={{ color: "red" }}>*</sup>
                      </label>
                      <input
                        id="fiscal"
                        style={{ fontSize: "13px" }}
                        type="text"
                        className="form-control form-control-sm "
                        name="fiscal"
                        value={fiscalFormValue.fiscal}
                        onChange={handleChange}
                      />
                      {fiscalFormError.fiscal && (
                        <p className="errormsg">{fiscalFormError.fiscal}</p>
                      )}
                    </div>
                  </div>

                  <div className="row text-start ">
                    <div className="col-md-6 col-sm-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="start" style={{ fontSize: "12px" }}>
                          {mode === "en" ? "Start Date" : "सुरू मिति"}{" "}
                          <sup style={{ color: "red" }}>*</sup>
                        </label>
                        <input
                          id="start"
                          style={{ fontSize: "13px" }}
                          type="text"
                          className="form-control form-control-sm"
                          name="start"
                          value={fiscalFormValue.start}
                          onChange={handleChange}
                        />
                        {fiscalFormError.start && (
                          <p className="errormsg">{fiscalFormError.start}</p>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="end" style={{ fontSize: "12px" }}>
                          {mode === "en" ? "End Date" : "अन्त्य मिति"}{" "}
                          <sup style={{ color: "red" }}>*</sup>
                        </label>
                        <input
                          id="end"
                          style={{ fontSize: "13px" }}
                          type="text"
                          className="form-control form-control-sm"
                          name="end"
                          value={fiscalFormValue.end}
                          onChange={handleChange}
                        />
                        {fiscalFormError.end && (
                          <p className="errormsg">{fiscalFormError.end}</p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* <div className="checkbox-close mt-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="exampleCheck2"
                      name="closeChecked"
                      onChange={handleOnChange}
                      checked={isCurrent}
                      style={{ fontSize: "12px", marginTop: "7px" }}
                    />
                    <label
                      class="form-check-label"
                      for="exampleCheck2"
                      style={{ fontSize: "12px", paddingLeft: "4px" }}
                    >
                      {mode === "en" ? "Current" : "वर्तमान"}
                    </label>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="new-footer">
            <div className="row  mt-1 mb-1">
              <div>
                <button
                  type="button"
                  class="btn btn-sm me-2"
                  style={{ background: "var(--button-color)", color: "white" }}
                  onClick={formSubmit}
                >
                  {mode === "en" ? "Submit" : "बुझाउनुहोस्"}
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-danger me-3"
                  style={{ color: "white" }}
                  onClick={closePopUp}
                >
                  {mode === "en" ? "Cancel" : "बन्द गर्नुहोस्"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
